<template>
  <main-layout>
    <template #nav>
      <div class="flex justify-between items-center">
        <router-link
          class="relative inline-flex items-center p-1.5 text-sm font-medium text-center rounded-full border-2 border-secondary-600 focus:ring-0 focus:outline-none focus:ring-primary-600"
          :to="{
            name: 'Home',
            query: {
              token: Jwt,
            },
          }">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4202">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
        </router-link>
        <h1 class="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">My Basket</h1>
        <div />
      </div>
    </template>
    <slot v-if="IsLoadingBasket">
      loading
    </slot>
    <div
      class="p-4 mt-4"
      v-if="!IsLoadingBasket && !BasketItems.length"
    >
      <no-data
        message="Looks like you haven't added anything in your basket"
        title="Your basket is Empty"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 w-10 h-10 text-secondary-600 transition duration-75 group-hover:text-gray-900">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
          </svg>
        </template>
        <router-link
          :to="{
            name: 'Home',
            query: {
              token: Jwt,
            },
          }"
          class="inline-flex text-secondary-600 bg-primary-600 hover:bg-primary-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4"
        >
          Explore products
        </router-link>
      </no-data>
    </div>

    <div
      class="p-4"
      v-if="BasketItems.length"
    >
      <div class="col-span-7 mb-10 space-y-4">
        <basket-item-card
          @update-quantity="updateQuantity"
          @remove="remove"
          class="mb-4"
          :id="item.id"
          :key="item.id"
          :name="item.product.name"
          :product-id="item.product.id"
          :currency="Currency"
          :quantity="item.quantity"
          :price="item.product.price"
          :image-url="item.product.imageUrl"
          v-for="item in BasketItems"
        />
      </div>
      <div class="col-span-5">
        <order-summary-card />
      </div>
    </div>
  </main-layout>
</template>

<script setup>
import { computed } from 'vue';
import { useBasketStore } from '@/stores/basket';
import { useAccountStore } from '@/stores/account';

import BasketItemCard from '@/components/basket/BasketItemCard.vue';
import OrderSummaryCard from '@/components/basket/OrderSummaryCard.vue';
import MainLayout from '@/layouts/MainLayout.vue';
import NoData from '@/components/shared/NoData.vue';

const CustomerId = computed(() => useAccountStore().CustomerId);
const BasketItems = computed(() => useBasketStore().Data);
const Currency = computed(() => useAccountStore().Currency);

const IsLoadingBasket = computed(() => useBasketStore().IsLoading);
const Jwt = computed(() => useAccountStore().Jwt);

const {
  Add,
  SetData: SetBasketItems,
  Remove: DeleteItem,
} = useBasketStore();

const updateQuantity = async (payload) => {
  await Add({
    customerId: CustomerId.value,
    data: {
      quantity: payload.quantity,
      productId: payload.productId,
    },
  });
  const items = BasketItems.value
    .map((it) => (it.id === payload.id ? {
      ...it,
      quantity: payload.quantity,
    } : it));
  SetBasketItems(items);
};
const remove = async (id) => {
  await DeleteItem(id);
  const items = BasketItems.value.filter((item) => item.id !== id);
  SetBasketItems(items);
};
</script>
